var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("conversation-list", {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.isBusy,
            expression: "isBusy",
          },
        ],
        ref: "list",
        attrs: {
          "index-url": _vm.indexUrl,
          margin: 16,
          "is-edit": _vm.isEditPage,
        },
        on: {
          delete: _vm.onDelete,
          edit: _vm.onEdit,
          "open-chat": _vm.onOpenChat,
          move: _vm.onMove,
        },
      }),
      _vm._v(" "),
      _c(
        "conversation-dialog",
        _vm._b({}, "conversation-dialog", _vm.chatProps, false)
      ),
      _vm._v(" "),
      _c("move-to-group-dialog", {
        attrs: { "search-url": _vm.sendListSearchUrl },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }